export default __webpack_public_path__ + "static/media/Hair_17_F_C3.557488d3.svg";